import React from "react";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { MainPageLayoutWrapper } from "../components/MainPageLayoutWrapper";
import { RouteConfig, routeConfig } from "../route-config";
import { useTranslate } from "@obsbot/remo-i18n";
import { RemoThemeBodyProvider } from "remo-components";
import { AppRouteErrorBoundary } from "./AppRouteErrorBoundary";
// import GameOverlayPage from "../pages/GameOverlayPage";

export function AppRoutes(): React.ReactElement {
    const t = useTranslate();

    return (
        <HashRouter>
            <Routes>
                {/* <Route element={<GameOverlayPage />} path="/screen/game-overlay/:roomUUID"></Route> */}
                <Route element={<Navigate replace to="/login" />} path="/" />
                <Route element={<MainPageLayoutWrapper />} path="/">
                    {Object.keys(routeConfig).map(((name: string) => {
                        const routeName = name as keyof RouteConfig;
                        // @ts-ignore
                        const { title, path, component, children } = routeConfig[routeName];
                        return (
                            <Route
                                key={name}
                                element={
                                    <RemoThemeBodyProvider>
                                        <AppRouteErrorBoundary
                                            Comp={component}
                                            title={t("title-" + title)}
                                        />
                                    </RemoThemeBodyProvider>
                                }
                                path={path}
                            >
                                {children?.map((child: any) => (
                                    <Route
                                        key={child.title}
                                        element={
                                            <RemoThemeBodyProvider>
                                                <AppRouteErrorBoundary
                                                    Comp={child.component}
                                                    title={t("title-" + child.title)}
                                                />
                                            </RemoThemeBodyProvider>
                                        }
                                        path={child.path}
                                    />
                                ))}
                            </Route>
                        );
                    }) as (name: string) => React.ReactElement)}
                </Route>
            </Routes>
        </HashRouter>
    );
}
